<template>
  <div :key="action + bookingId">
    <BookingForm
      :action="action"
      :default-rooms="defaultBookingRooms"
      :booking-id="bookingId"
    ></BookingForm>
  </div>
</template>
<script>
import BookingForm from '@/components/resources/booking/BookingForm.vue'

export default {
  components: { BookingForm },
  data() {
    return {
      defaultBookingRooms: null
    }
  },
  computed: {
    bookingId() {
      return this.$route.query?.id
    },
    action() {
      const actions = ['create', 'edit', 'view']
      const queryAction = this.$route.query?.action
      if (!actions.includes(queryAction)) {
        return 'create'
      } else {
        return queryAction
      }
    }
  },
  created() {
    const selectRooms = sessionStorage.getItem('defaultRooms')

    sessionStorage.removeItem('defaultRooms')

    this.defaultBookingRooms = selectRooms ? JSON.parse(selectRooms) : null
  }
}
</script>
